const Skills = () => {
  return (
    <div className="mx-60 grid grid-cols-3 grid-rows-2 gap-28 text-white my-20">
      <div>
        <p className="text-5xl mb-4 font-custom">SkillSet</p>
        <h2>By going through Documentation and watching some tutorials I have acquired these skills.</h2>
      </div>
      <div>
        <p className="text-4xl mb-4">FrontEnd</p>
        <ul className="list-disc mx-8 text-lg">
          <li><i className="fa-brands fa-html5"></i> HTML</li>
          <li><i className="fa-brands fa-css3-alt"></i> CSS</li>
          <li><i className="fa-brands fa-js"></i> JavaScript</li>
          <li><i className="fa-brands fa-react"></i> React</li>
          <li>TailWind</li>
        </ul>
      </div>
      <div className="list-disc mx-8">
        <p className="text-4xl mb-4">BackEnd&DataBase</p>
        <ul className="list-disc mx-8 text-lg">
          <li><i className="fa-brands fa-node-js"></i> Node</li>
          <li> Express</li>
          <li>MongoDB</li>
          <li>FireBase</li>
        </ul>
      </div>
      <div></div>
      <div>
        <p className="text-4xl mb-4">Tools&Kits</p>
        <ul className="list-disc mx-8 text-lg">
          <li>Git</li>
          <li>Linux</li>
        </ul>
      </div>
    </div>
  )
};
export default Skills;  
